import { render, staticRenderFns } from "./LeftBarDOD.vue?vue&type=template&id=6e583a45&scoped=true&"
import script from "./LeftBarDOD.vue?vue&type=script&lang=js&"
export * from "./LeftBarDOD.vue?vue&type=script&lang=js&"
import style0 from "./LeftBarDOD.vue?vue&type=style&index=0&id=6e583a45&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e583a45",
  null
  
)

export default component.exports